<template>
  <div class="dashboard-pages about">
    <h1>This Is The About Page</h1>
  </div>
</template>

<script>
export default {}
</script>
